import { render, staticRenderFns } from "./GiftCheckoutMobile.vue?vue&type=template&id=2e088491"
import script from "./GiftCheckoutMobile.vue?vue&type=script&lang=js"
export * from "./GiftCheckoutMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports